export default __webpack_public_path__ + "static/media/1817.9cc701d1.png";